import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { array, bool, func, object, shape, string } from 'prop-types';
import moment from 'moment';

import { getRecentJobs } from './RecentJobsActions';

import './RecentJobs.scss';

RecentJobs.propTypes = {
  data: shape({
    recentJobs: {
      jobs: array,
      loading: bool,
      loaded: bool,
      error: string
    }
  }),
  organizationCode: string,
  actions: shape({
    getRecentJobs: func
  })
};

function RecentJobs(props) {
  useEffect(() => {
    if (!props.data.landingDashboard?.loading && !props.data.landingDashboard?.loaded) {
      props.actions.getRecentJobs();
    }
  }, []);

  function formatDate(date) {
    return moment(date).format('YYYY-MM-DD, hh:mm:ss');
  }

  function getRecentJobsList() {
    const { jobs } = props.data.recentJobs;
    const list = [];

    for (let key in jobs) {
      const job = jobs[key];
      const {
        org_job_id: id,
        org_job_code: code,
        org_job_code_key: codeKey,
        org_job_title: title,
        slot_p: status,
        last_modified: time
      } = job;
      const link = `${window.location.origin}/view/o/${props.organizationCode}/mp/market-analysis/jobs/${id}/pricing`;

      list.push(
        <div className="recent-jobs__list-item">
          <a className="job" href={link} target="_blank" rel="noreferrer" key={`recent-${id}`}>
            {`${title} (${code}${codeKey.trim() ? `, ${codeKey}` : ''})`}
          </a>

          <div className="sub-text">
            {`${status === 'slotted' ? 'Slotted' : 'Priced'}, Last Modified: ${formatDate(time)}`}
          </div>
        </div>
      );
    }

    return list;
  }

  return (
    <div className="dashboard-grid__recent-jobs">
      {props.data.recentJobs?.error ? (
        <div className="recent-jobs__error">{`Error: ${props.data.recentJobs?.error}`}</div>
      ) : (
        getRecentJobsList()
      )}
    </div>
  );
}

const mapStateToProps = ({ landingDashboard, session }) => ({
  data: landingDashboard.RecentJobsReducer,
  organizationCode: session.organization.code
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getRecentJobs
    },
    dispatch
  )
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RecentJobs));
